import { openModal } from "./modal";

export type TutorialDifficulty = "debutant" | "avance";

/**
 * Choix du niveau avant de lancer le tutoriel de strategie ou les exercices
 * (cf. `difficulty` sur `TutorialStep`/`Exercise`) : retourne `null` si le joueur
 * annule (aucune etape n'est alors lancee, le menu reste affiche).
 */
export function showDifficultyModal(title: string): Promise<TutorialDifficulty | null> {
  return new Promise((resolve) => {
    const content = document.createElement("div");
    content.innerHTML = `
      <h2>${title}</h2>
      <p>Choisis ton niveau, l'ami.</p>
      <div class="menu-actions">
        <button class="btn btn-primary" id="difficulty-debutant" type="button">Debutant</button>
        <button class="btn" id="difficulty-avance" type="button">Avance</button>
        <button class="btn btn-ghost" id="difficulty-cancel" type="button">Annuler</button>
      </div>
    `;
    const { close } = openModal(content, { dismissible: false });
    const finish = (value: TutorialDifficulty | null) => {
      close();
      resolve(value);
    };
    content.querySelector<HTMLButtonElement>("#difficulty-debutant")?.addEventListener("click", () => finish("debutant"));
    content.querySelector<HTMLButtonElement>("#difficulty-avance")?.addEventListener("click", () => finish("avance"));
    content.querySelector<HTMLButtonElement>("#difficulty-cancel")?.addEventListener("click", () => finish(null));
  });
}
